var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"m-the-header-logo",attrs:{"disabled":!_vm.isLoading,"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goToHome()}}},[_c('AtomLogoPrimary')],1)}
var staticRenderFns = []

export { render, staticRenderFns }